import { Workout, Interval } from '../types/workout';

export function getWorkoutDuration(workout: Workout): number {
  return expandWorkoutToIntervals(workout).reduce(
    (total, interval) => total + interval.duration,
    0
  );
}

export function formatTime(seconds: number): string {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}

// Utility function to expand workout sections into individual intervals
export function expandWorkoutToIntervals(workout: Workout): Interval[] {
  const allIntervals: Interval[] = [];

  workout.sections.forEach((section) => {
    if (section.type === 'block') {
      // Single block - just add it as one interval
      allIntervals.push({
        duration: section.duration,
        targetPower: section.targetPower,
        durationValid: section.durationValid,
        powerValid: section.powerValid,
      });
    } else if (section.type === 'interval') {
      // Interval set - repeat the on/rest pattern
      for (let i = 0; i < section.repeats; i++) {
        allIntervals.push({
          duration: section.onInterval.duration,
          targetPower: section.onInterval.targetPower,
          durationValid: section.onInterval.durationValid,
          powerValid: section.onInterval.powerValid,
        });
        allIntervals.push({
          duration: section.restInterval.duration,
          targetPower: section.restInterval.targetPower,
          durationValid: section.restInterval.durationValid,
          powerValid: section.restInterval.powerValid,
        });
      }
    } else if (section.type === 'ramp') {
      // Ramp section - treat as single interval with start power (power will ramp during execution)
      allIntervals.push({
        duration: section.duration,
        targetPower: section.startPower,
        durationValid: section.durationValid,
        powerValid: section.startPowerValid && section.endPowerValid,
      });
    }
  });

  return allIntervals;
}
